import {useService} from '@cindedi/react-application';
import type {MetaFunction, LoaderFunction} from '@remix-run/node';
import {json} from '@remix-run/node';
import {useLoaderData} from '@remix-run/react';
import {PostList} from '~/domains/blog/components/PostList';
import {PublicLayout} from '~/domains/organization/components/PublicLayout';
import {seoMeta} from '~/domains/organization/utilities/seoMeta';

export interface NoticiasLoaderData {
  posts: Blog.PublicPostDto[];
}

export const meta: MetaFunction = function NoticiasMeta({matches}) {
  return seoMeta('noticias', {title: 'Notícias - Cindedi', description: 'Acompanhe as notícias do CINDEDI e fique por dentro de estudos e avanços em desenvolvimento humano e educação infantil. Leia e compartilhe!'}, matches);
};

export const loader: LoaderFunction = async function NoticiasLoader({context: {use}}) {
  const Post = use('Post');
  const posts = await Post.all({where: {published: true}});

  return json({posts: posts.sortByDesc('publishedAt').all()});
};

export default function NoticiasView() {
  const data = useLoaderData<NoticiasLoaderData>();
  useService('organization/titlebar').setTitle('Notícias');

  return (
    <PublicLayout>
      <PostList posts={data.posts} />
    </PublicLayout>
  );
}
